module.exports = __webpack_public_path__ + "static/img/day-1.8825953.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/day-1.png
// module id = BPKQ
// module chunks = 1